import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createUser,
  getUserFilterDetail,
} from "reduxStore/action/usersActions";
import { getCityList } from "reduxStore/action/masterActions";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import strings from "translate/language";
import Select from "react-select";
import {
  emailAddressValid,
  getAge,
  handleListResponse,
  isEmpty,
  mobileNumberValid,
  nameValid,
  seo,
  ValidateExtensionImge,
  validateAadhaar,
  pancardValidation,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Input from "../../component/Input";
import Button from "../../component/Button";
import moment from "moment";
import { getRoleList } from "reduxStore/action/roleActions";
import {
  ChannelPartner,
  CPAgent,
  LoginType,
  ClosingManager,
  SourcingManager,
  SourcingTL,
  ClosingTL,
  emailEndPoint,
  SiteHead,
  ClusterHead,
  BusinessHead,
  AdminRoleId,
} from "utils/constants";
import {
  CallCenter,
  HR,
  PostSale,
  Receptionist,
  SubAdmin,
  SupportRequest,
} from "../../utils/constants";

const UserListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [userList, setUserList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const RegisterAddUserSelector = useSelector((state) => state.userData);
  const userListSelector = useSelector((state) => state.userData);
  const getRoleListSelector = useSelector((state) => state.roleData);
  const GetCityListSelector =
    useSelector((state) => state.cityMasterData?.response?.data) || [];

  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionImge(e.target);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        preview: preview,
        raw: image,
      };
      setImage(nextFormState);
    }
  };
  useEffect(() => {
    seo({
      title: "Add New User",
      metaDescription: "Add new user",
      canonicalLink: window.location.href,
    });
  }, []);
  useEffect(() => {
    const { response } = getRoleListSelector;
    if (response) {
      if (response?.status === 200) {
        let filterData = handleListResponse(response.data).filter(
          (i) =>
            i._id !== CPAgent &&
            i._id !== ChannelPartner &&
            i._id !== HR &&
            i._id !== PostSale &&
            i._id !== Receptionist &&
            i._id !== CallCenter &&
            i._id !== SubAdmin
        );
        setRolesList(filterData);
      } else {
        setRolesList([]);
      }
    }
  }, [getRoleListSelector]);
  useEffect(() => {
    dispatch(getCityList());
    dispatch(getRoleList());
  }, [dispatch]);

  useEffect(() => {
    if (userListSelector?.userData) {
      const { userData } = userListSelector;
      if (userData?.status === 200) {
        const list = handleListResponse(userData?.data).filter((el) => {
          return form.role_id === ClosingManager
            ? el?.role_id === ClosingTL
            : form.role_id === SourcingManager
              ? el?.role_id === SourcingTL
              : form.role_id === ClosingTL || form.role_id === SourcingTL
                ? el?.role_id === SiteHead ||
                el?.role_id === ClusterHead ||
                el?.role_id === BusinessHead ||
                el?.role_id === AdminRoleId
                : form.role_id === SiteHead
                  ? el?.role_id === ClusterHead ||
                  el?.role_id === BusinessHead ||
                  el?.role_id === AdminRoleId
                  : form.role_id === ClusterHead
                    ? el?.role_id === BusinessHead || el?.role_id === AdminRoleId
                    : form.role_id === BusinessHead
                      ? el?.role_id === AdminRoleId
                      : form.role_id === HR
                        ? el?.role_id === AdminRoleId
                        : form.role_id === SupportRequest
                          ? el?.role_id === AdminRoleId
                          : form.role_id === PostSale
                            ? el?.role_id === AdminRoleId
                            : form.role_id === Receptionist
                              ? el?.role_id === AdminRoleId
                              : form.role_id === CallCenter
                                ? el?.role_id === AdminRoleId
                                : form.role_id === SubAdmin
                                  ? el?.role_id === AdminRoleId
                                  : "";
        });
        setUserList(list);
        // setUserList(handleListResponse(userData?.data));
      } else {
        setUserList([]);
      }
    }
  }, [userListSelector]);

  useEffect(() => {
    if (RegisterAddUserSelector.create === true) {
      if (RegisterAddUserSelector?.userData?.status === 200) {
        setForm({});
        navigate("/user");
      }
    }
  }, [RegisterAddUserSelector, navigate]);

  const handleInputField = (e) => {
    var nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
            .replace(/\D/g, "")
            .split(/(?:([\d]{4}))/g)
            .filter((s) => s.length > 0)
            .join(" ")
          : e.target.value,
    };

    if (e.target.name === "role_id") {
      nextFormState = {
        ...form,
        isHeadTL: "",
        [e.target.name]:
          e.target.name === "adhar_no"
            ? e.target.value
              .replace(/\D/g, "")
              .split(/(?:([\d]{4}))/g)
              .filter((s) => s.length > 0)
              .join(" ")
            : e.target.value,
      };
      dispatch(
        getUserFilterDetail({
          limit: 500,
          offset: 0,
        })
      );
    }
    setForm(nextFormState);
  };
  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      area: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, area) => {
    const nextFormState = {
      ...form,
      area: area,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      formData.append("profile_picture", image.raw);
      formData.append("role_id", form.role_id);
      formData.append("firstname", form.firstname);
      formData.append("lastname", form.lastname);
      formData.append("email", form.email + emailEndPoint);
      formData.append("gender", form.gender);
      formData.append("mobile", form?.mobile);
      formData.append("dateofbirth", form.dateofbirth ? form.dateofbirth : "");
      formData.append("pancard_no", form?.pancard_no ? form?.pancard_no : "");
      formData.append("adhar_no", form.adhar_no ? form.adhar_no : "");
      formData.append("address", form.address ? form.address : "");
      formData.append("city", form.city ? form.city : "");
      formData.append("city_id", form.city_id ? form.city_id : 0);
      formData.append("area", form.area ? form.area : "");
      formData.append(
        "justo_employee_code",
        form.justo_employee_code ? form.justo_employee_code : ""
      );
      formData.append("longitude", form.longitude ? form.longitude : "");
      formData.append("latitude", form.latitude ? form.latitude : "");

      formData.append("sourcing_head", form.isHeadTL);

      formData.append("login_type", form.login_type);
      dispatch(createUser(formData));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.firstname) {
      formError = true;
      err["firstname"] = strings.firstnameErr;
    } else if (!nameValid(form.firstname)) {
      formError = true;
      err["firstname"] = strings.nameValidErr;
    }
    if (!form.lastname) {
      formError = true;
      err["lastname"] = strings.lastnameErr;
    } else if (!nameValid(form.lastname)) {
      formError = true;
      err["lastname"] = strings.nameValidErr;
    }
    if (!form.email) {
      formError = true;
      err["email"] = strings.emailErr;
    } else if (!emailAddressValid(form.email + emailEndPoint)) {
      formError = true;
      err["email"] = strings.useremailErr;
    }
    if (!form.mobile) {
      formError = true;
      err["mobile"] = strings.mobileErr;
    } else if (form.mobile && !mobileNumberValid(form.mobile)) {
      formError = true;
      err["mobile"] = strings.mobileValidErr;
    }
    if (Number(form.gender) === 1 || Number(form.gender) === 2) {
    } else {
      formError = true;
      err["gender"] = strings.genderErr;
    }
    // if (!form.dateofbirth) {
    //   formError = true;
    //   err["dateofbirth"] = strings.dateofbirthErr;
    // } else
    if (getAge(form.dateofbirth) < 18) {
      formError = true;
      err["dateofbirth"] = strings.dateofbirthErr2;
    }
    if (form.adhar_no && !validateAadhaar(form.adhar_no)) {
      formError = true;
      err["adhar_no"] = strings.validAadhar_Err;
    }
    if (form.pancard_no && !pancardValidation(form.pancard_no)) {
      formError = true;
      err["pancard_no"] = strings.validPancard_Err;
    }
    // if (!form.address) {
    //   formError = true;
    //   err["address"] = strings.addressErr;
    // }
    // if (!form.city_id) {
    //   formError = true;
    //   err["city_id"] = strings.cityErr;
    // } else if (form.city_id === strings.city) {
    //   formError = true;
    //   err["city_id"] = strings.cityErr;
    // }
    // if (!form.area) {
    //   formError = true;
    //   err["area"] = strings.areaErr;
    // } else
    // if (!form.longitude && form.longitude == "") {
    //   formError = true;
    //   err["area"] = strings.validAddressErr;
    // } else
    //  if (form.longitude === "undefined") {
    //   formError = true;
    //   err["area"] = strings.validAddressErr;
    // }
    if (!form.justo_employee_code) {
      formError = true;
      err["justo_employee_code"] = strings.justoEmpCodeErr;
    }
    if (!form.role_id) {
      formError = true;
      err["role_id"] = strings.role_idErr;
    } else if (form.role_id === strings.selectRole) {
      formError = true;
      err["role_id"] = strings.role_idErr;
    }

    if (!form.isHeadTL) {
      formError = true;
      err["is_head_tl"] = strings.parentErr;
    } else if (form.isHeadTL === strings.selectParent) {
      formError = true;
      err["is_head_tl"] = strings.parentErr;
    }

    if (!form.login_type) {
      formError = true;
      err["login_type"] = strings.login_type;
    }

    if (!isEmpty(err)) {
      formError = true;
    }
    setFormVaild(err);
    return formError;
  };
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.addnewuser}
        url={"/user"}
        parentListing={strings.userListing}
        titleactive={strings.addNewUser}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.addNewUser}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="upload-button">
                        <img
                          src={
                            image.preview
                              ? image.preview
                              : "/assets/images/user.png"
                          }
                          width="150"
                          height="150"
                          style={{ borderRadius: "50%" }}
                          color="red"
                          title={strings.selectImage}
                          alt={strings.selectImage}
                        />
                      </label>
                      <Input
                        type="file"
                        id="upload-button"
                        name="profile_picture"
                        style={{ display: "none" }}
                        onChange={handleChange}
                      />
                      <br />
                    </div>
                  </div>
                  {formVaild?.validMedia && (
                    <span style={{ color: "red" }}>{formVaild.validMedia}</span>
                  )}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="justo_employee_code"
                          placeholder={strings.justoEmpCode}
                          value={form.justo_employee_code}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.justoEmpCode}
                          requiredLabel={true}
                          error={formVaild?.justo_employee_code}
                          maxLength={30}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="firstname"
                          placeholder={strings.firstName}
                          value={form.firstname}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.firstName}
                          requiredLabel={true}
                          error={formVaild?.firstname}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          name="lastname"
                          placeholder={strings.lastName}
                          value={form.lastname}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.lastName}
                          requiredLabel={true}
                          error={formVaild?.lastname}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.emailAddress}
                          <span className="required-field"></span>
                        </label>
                        <div class="input-group">
                          <input
                            className="form-control"
                            autocomplete="off"
                            id="exampleFormControlLastName"
                            type="text"
                            name="email"
                            value={form.email}
                            placeholder={strings.EmailUsername}
                            onChange={handleInputField}
                            autoComplete="off"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text">@justo.co.in</span>
                          </div>
                        </div>
                        {formVaild?.email && (
                          <span style={{ color: "red" }}>
                            {formVaild?.email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          placeholder={strings.mobileNo}
                          name="mobile"
                          value={form.mobile}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.mobileNo}
                          error={formVaild?.mobile}
                          requiredLabel={true}
                          maxLength={10}
                          isNumber={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pb-3">
                    <div className="row pl-4">
                      <label htmlFor="exampleInputMobileNo " className="pr-4">
                        {strings.gender}
                        <span className="required-field"></span>
                      </label>
                      <div className="form-check pr-4">
                        <input
                          className="form-check-input "
                          type="radio"
                          name="gender"
                          value={1}
                          onChange={handleInputField}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          {strings.male}
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          value={2}
                          onChange={handleInputField}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          {strings.female}
                        </label>
                      </div>
                    </div>
                    {formVaild?.gender && (
                      <span style={{ color: "red" }}>{formVaild?.gender}</span>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          placeholder={strings.dob}
                          name="dateofbirth"
                          type="date"
                          value={form.dateofbirth}
                          onChange={handleInputField}
                          label={strings.dob}
                          error={formVaild?.dateofbirth}
                          minDateRange="1920-01-01"
                          maxDateRange={moment()
                            .subtract(18, "years")
                            .format("yyyy-MM-DD")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.aadharNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlLastName"
                          type="text"
                          maxLength={14}
                          name="adhar_no"
                          value={form.adhar_no}
                          placeholder={strings.aadharNoExample}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.adhar_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.adhar_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.pancardNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="pancard_no"
                          maxLength={10}
                          value={form.pancard_no}
                          placeholder={strings.panNumberExample}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.pancard_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.pancard_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.city}
                        </label>
                        <Select
                          isSearchable
                          isClearable
                          options={GetCityListSelector}
                          getOptionLabel={(option) => `${option.city_name}`}
                          getOptionValue={(option) => option.city_id}
                          name="cityObj"
                          value={form.cityObj}
                          onChange={(val) => {
                            const nextFormState = {
                              ...form,
                              cityObj: val,
                            };
                            if (val) {
                              nextFormState.city = val?.city_name;
                              nextFormState.city_id = val?.city_id;
                            } else {
                              nextFormState.city = "";
                              nextFormState.city_id = "";
                            }
                            setForm(nextFormState);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          isSearchable
                          isClearable
                          placeholder={strings.address}
                          name="address"
                          value={form.address}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.address}
                          error={formVaild?.address}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <AutocompletePlace
                          placeholder={strings.area}
                          value={form.area}
                          onChange={handleInputArea}
                          onSelect={onSelect}
                          error={formVaild?.area}
                          label={strings.area}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.role}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          name="role_id"
                          value={form.role_id}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectRole}</option>
                          {rolesList.map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.role_title}
                            </option>
                          ))}
                        </select>
                        {formVaild?.role_id && (
                          <span style={{ color: "red" }}>
                            {formVaild?.role_id}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.parent}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          name="isHeadTL"
                          onChange={handleInputField}
                          value={form?.isHeadTL}
                        >
                          <option value="">{strings.selectParent}</option>
                          {userList.map((item, index) => (
                            <option key={index} value={item._id}>
                              {`${item.firstname} ${item.lastname} (${item?.role_title})`}
                            </option>
                          ))}
                        </select>
                        {formVaild?.is_head_tl && (
                          <span style={{ color: "red" }}>
                            {formVaild?.is_head_tl}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-8">
                      <div>
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.parent}
                          <span className="required-field"></span>
                        </label>
                        <Select
                          isSearchable
                          isClearable
                          onInputChange={(e) => {
                            dispatch(
                              getUserFilterDetail({
                                limit: 500,
                                offset: 0,
                                search_name: e,
                                isLoadMore: true,
                              })
                            );
                          }}
                          placeholder={strings.selectParent}
                          options={userList}
                          getOptionLabel={(option) =>
                            `${option?.firstname} ${option?.lastname} (${option?.role_title})`
                          }
                          getOptionValue={(option) => option._id}
                          name="isHeadTL"
                          value={form?.parentUser}
                          onChange={(e) => {
                            setForm({
                              ...form,
                              isHeadTL: e._id,
                              parentUser: e,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {formVaild?.is_head_tl && (
                    <span style={{ color: "red" }}>
                      {formVaild?.is_head_tl}
                    </span>
                  )} */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mt-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.loginAccess}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          name="login_type"
                          value={form.login_type}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectLoginType}</option>
                          {LoginType.map((item, index) => (
                            <option key={index} value={item.value}>
                              {`${item.lable}`}
                            </option>
                          ))}
                        </select>
                        {formVaild?.login_type && (
                          <span style={{ color: "red" }}>
                            {formVaild?.login_type}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-footer float-right">
                      <Button
                        onClick={() => handleSubmit()}
                        label={strings.submit}
                      ></Button>
                    </div>
                  </div>
                </div>
                {!isEmpty(formVaild) && (
                  <span
                    style={{
                      color: "red",
                      float: "right",
                    }}
                  >
                    {strings.allFieldRequired}
                  </span>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserListing;
